import {Component, ElementRef, Inject, LOCALE_ID, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ProgressService} from '../../service/progress.service';
import {BaseModalComponent} from '../../common/modal/base-modal/base-modal.component';
import {NotificationHandler} from '../../helper/notification.handler';
import {CertificateService} from '../../service/certificate.service';
import {Contest} from '../../model/contest/Contest';
import {ContestService} from '../../service/contest.service';
import {DataHelper} from '../../helper/data.helper';
import {DomSanitizer} from '@angular/platform-browser';
import {UserCertificateType} from '../../model/contest/Certificate';

export interface ContestTeacherInfoDetailsData {
  competitionId: string;
  contestId: string;
  userId: string;
}

@Component({
  selector: 'app-contests-teacher-info-modal',
  templateUrl: './contests-teacher-info-modal.component.html',
  styleUrls: ['./contests-teacher-info-modal.component.scss'],
})
export class ContestsTeacherInfoModalComponent extends BaseModalComponent implements OnInit {

  @ViewChild('dialogContent', {static: true}) protected progressContainer!: ElementRef;

  protected competitionId: string;
  protected contestId: string;
  protected userId: string;

  contest?: Contest;

  certificateNotConfigured = false;

  certificateGetInProgress = false;
  certificateUrl?: string;

  constructor(dialogRef: MatDialogRef<ContestsTeacherInfoModalComponent>,
              private certificateService: CertificateService,
              private contestService: ContestService,
              public sanitizer: DomSanitizer,
              progressService: ProgressService,
              @Inject(MAT_DIALOG_DATA) data: ContestTeacherInfoDetailsData,
              @Inject(LOCALE_ID) private locale: string) {
    super(dialogRef, progressService);

    this.competitionId = data?.competitionId;
    this.contestId = data?.contestId;
    this.userId = data?.userId;
  }

  isContestFinished(contest: Contest): boolean {
    return !!contest.endsAt && contest.endsAt < new Date();
  }

  ngOnInit(): void {
    this.loadContest();
  }

  proceed(): void {
  }

  proceedAllowed(): boolean {
    return true;
  }

  private loadContest() {
    if (!this.contestId) return;

    this.startProgress();

    this.contestService.getDetails(this.contestId, true).subscribe({
      next: contest => {
        this.contest = contest;

        this.stopProgress();
      }, error: error => {
        NotificationHandler.handleError($localize`:Notifications|Contest details fetch has failed message@@notifications-contest-details-fetch-failed-error:Contest details fetch has failed`, error);
        this.stopProgress();
      }
    });
  }

  requestCertificate() {
    if (!this.contestId || this.certificateNotConfigured || !this.userId) return;

    this.certificateGetInProgress = true;
    this.certificateUrl = undefined;

    this.certificateService.requestCertificate(this.contestId, this.userId, UserCertificateType.teacher).subscribe({
      next: certificate => {
        if (certificate.url) {
          this.certificateUrl = certificate.url;
          DataHelper.downloadFile(certificate.url);
        } else {
          this.certificateNotConfigured = true;
          NotificationHandler.handleWarning($localize`:Notifications|Contest certificates are not configured for contest message@@notifications-contest-certificate-not-configured-for-contest-error:Contest certificates are not configured for this contest by a host`);
        }

        this.certificateGetInProgress = false;
      }, error: error => {
        NotificationHandler.handleError($localize`:Notifications|Contest certificate request has failed message@@notifications-contest-certificate-request-failed-error:Contest certificate request has failed`, error);
        this.certificateGetInProgress = false;
      }
    });
  }
}
